import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ITrainingRecordDocumentSummary } from '../../../message-models/training-record-document-summary.interface';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-training-record-documents',
  templateUrl: './training-record-documents.component.html',
  styleUrls: ['./training-record-documents.component.scss']
})
export class TrainingRecordDocumentsComponent implements OnInit {
  @Input() showTableCaption: boolean;
  @Input() showHeaderText = true;
  @Input() headerText = 'Training Record Documents';
  @Input() addDocumentButtonText = 'Add';
  @Input() showAddDocumentButton = true;
  @Input() trainingRecordDocuments: Array<ITrainingRecordDocumentSummary> = new Array<ITrainingRecordDocumentSummary>();

  @Output() openDocument: EventEmitter<ITrainingRecordDocumentSummary> = new EventEmitter<ITrainingRecordDocumentSummary>();
  @Output() editDocument: EventEmitter<ITrainingRecordDocumentSummary> = new EventEmitter<ITrainingRecordDocumentSummary>();
  @Output() downloadDocument: EventEmitter<ITrainingRecordDocumentSummary> = new EventEmitter<ITrainingRecordDocumentSummary>();
  @Output() deleteDocument: EventEmitter<ITrainingRecordDocumentSummary> = new EventEmitter<ITrainingRecordDocumentSummary>();
  @Output() viewDocument: EventEmitter<ITrainingRecordDocumentSummary> = new EventEmitter<ITrainingRecordDocumentSummary>();
  @Output() addDocument: EventEmitter<void> = new EventEmitter<void>();

  rowMenuItems: MenuItem[];

  constructor() {
  }

  isOnMobile = false;
  ngOnInit(): void {
    this.isOnMobile = window.outerWidth <= 480;

    this.rowMenuItems = [
      {
        label: 'Open',
        icon: 'fas fa-search',
        styleClass: 'eca-menu-item-green',
        command: ($event) => this.openDocumentClicked($event)
      },
      {
        label: 'Edit',
        icon: 'fas fa-edit',
        styleClass: 'eca-menu-item-green',
        command: ($event) => this.editDocumentClicked($event)
      },
      {
        label: 'Download',
        icon: 'fas fa-download',
        styleClass: 'eca-menu-item-green',
        command: ($event) => this.downloadDocumentClicked($event)
      },
      {
        label: 'Delete',
        icon: 'fas fa-trash-alt',
        styleClass: 'eca-menu-item-red',
        command: ($event) => this.deleteDocumentClicked($event)
      }
    ]
  }

  openDocumentClicked(trainingRecordDocumentSummary: ITrainingRecordDocumentSummary) {
    this.openDocument.emit(trainingRecordDocumentSummary);
  }

  deleteDocumentClicked(trainingRecordDocumentSummary: ITrainingRecordDocumentSummary) {
    this.deleteDocument.emit(trainingRecordDocumentSummary);
  }

  downloadDocumentClicked(trainingRecordDocumentSummary: ITrainingRecordDocumentSummary) {
    this.downloadDocument.emit(trainingRecordDocumentSummary);
  }

  editDocumentClicked(trainingRecordDocumentSummary: ITrainingRecordDocumentSummary) {
    this.editDocument.emit(trainingRecordDocumentSummary);
  }

  addDocumentClicked() {
    this.addDocument.emit();
  }

  viewDocumentClicked(trainingRecordDocumentSummary: ITrainingRecordDocumentSummary) {
    this.viewDocument.emit(trainingRecordDocumentSummary);
  }
}
export class TableColumn {
  header: string;
  field: string;
  mobileCollapsed: boolean;
}
